import { type FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage';

import eligibilityChecksReducer from './slice';

/**
 * Eligibility Checks feature module definition
 */
export const eligibilityChecksFeature: FeatureModule = {
  id: 'eligibilityChecks',
  name: 'Eligibility Checks',
  dependencies: [],
  reducers: {
    eligibilityChecks: eligibilityChecksReducer,
  },
  middleware: [],
  persistence: {
    enabled: true,
    storage: storage,
    whitelist: ['warningDismissed'],
    version: 1,
    mergeStrategy: 'merge',
  },
  sync: {
    enabled: false,
  },
  setup: _store => {},
  cleanup: _store => {},
};

